import React, { useEffect, useState } from "react";
import { Card, Table } from "antd";
import { Button } from '../../../components/button';
import MgmtLayout from "../../../components/layouts/MgmtLayout";
import MgmtService from "../../../app/service/mgmtService";
import { Link } from "react-router-dom";

export const MgmtLogins = () => {
    const [logins, setLogins] = useState([]);
    const [loading, setLoading] = useState(false);

    const mgmtService = new MgmtService();

    const columns = [
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Cliente</div>
            },
            align: 'center',
            dataIndex: 'clientName',
            key: 'clientName',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Usuário</div>
            },
            align: 'center',
            dataIndex: 'username',
            key: 'username',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Descrição</div>
            },
            align: 'center',
            dataIndex: 'description',
            key: 'description',
            size: 80
        },
        {
            title: () => {
                return <div style={{ display: 'flex', color: 'white', fontSize: '14px', fontWeight: 500, justifyContent: 'center' }}>Telegram Chat ID</div>
            },
            align: 'center',
            dataIndex: 'telegramChatid',
            key: 'telegramChatid',
            size: 80
        },
    ]

    useEffect(() => {
        setLoading(true);

        mgmtService.getLogins().then(res => {
            setLogins(res.data.data);
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    }, []);

    return (
        <MgmtLayout>
            <Card title='Logins'>
                <Link to='/mgmt/login/create'><Button style={{ marginBottom: '15px' }}>+ Novo</Button></Link>

                <Table
                    size='small'
                    scroll={{ x: 240, y: 240 }}
                    style={{ width: '100%', overflow: 'hidden' }}
                    columns={columns}
                    dataSource={logins}
                    loading={loading}
                />
            </Card>
        </MgmtLayout>
    );
}